// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-subnav.scss
 ** module id = 56
 ** module chunks = 0 1
 **/